import { apiGet, apiPost } from '../../../utils/api';

export async function searchComps(q) {
  const res = await apiGet(`/management/comp_clients/search?q=${encodeURIComponent(q)}`);
  if (!res.ok) throw new Error('Search failed');
  return res.json();
}

export async function listComps(scope = 'mine') {
  const res = await apiGet(`/management/comp_clients?scope=${scope}`);
  if (!res.ok) throw new Error('Failed to load comps');
  return res.json();
}

// payload: { company_name, contact_email, contact_phone } OR { source_type, source_id }
export async function createComp(payload) {
  const res = await apiPost('/management/comp_clients', payload);
  if (!res.ok && res.status !== 200 && res.status !== 201) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.error || 'Comp failed');
  }
  return res.json();
}

export async function resendInvite(source_type, source_id) {
  const res = await apiPost('/management/comp_clients/resend_invite', { source_type, source_id });
  if (!res.ok) throw new Error('Resend failed');
  return res.json();
}
